// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"JsonWidget_editorContainer__c3IV8"};